export const IZS_API_KEY = '67506eca-a784-45b2-8697-9a83574c31e3';
